export const HAS_ACCESSED_BEFORE_KEY = 'key:hasAccessedBefore';
